module.exports = __webpack_public_path__ + "img/logo_redbook_mobile.78f52af5.png";